import { sqlFormat } from './sqlFormat.js';
import { xmlFormat } from './xmlFormat.js';
import { sqlSafeFormat } from './sqlSafeFormat.js';

class QueryBuilderFormat {
  format = {
    defaultFormat: (query) => query,
    sqlFormat,
    xmlFormat,
    sqlSafeFormat,
  };

  currentFormat = 'sqlFormat';

  setDefaultFormat = (formatName) => {
    if (this.format[formatName]) this.currentFormat = formatName;
  };

  addFormat = (formatName, format) => (this.format[formatName] = format);

  run = (query, formatName) => {
    if (this.format[formatName]) return this.format[formatName](query);
    return this.format[this.currentFormat](query);
  };
}

export default new QueryBuilderFormat();
